import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLanguage } from "../i18n";
import { Reveal, Eyebrow } from "./Reveal";
import { GALLERY, SHOW_PHOTOS } from "../data";

export const Gallery = () => {
  const { lang, t } = useLanguage();
  const [active, setActive] = useState(null);

  if (!SHOW_PHOTOS) return null;

  return (
    <section
      id="galleria"
      data-testid="restaurant-gallery-section"
      className="relative py-24 sm:py-36"
      style={{ backgroundColor: "#F5EFE6" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Reveal>
              <Eyebrow>{t.gallery.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-display font-light text-3xl sm:text-4xl lg:text-[2.75rem] tracking-tight text-[#2C0F1A]">
                {t.gallery.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={i * 0.06} className="mb-5 break-inside-avoid">
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(i)}
                className="group relative block w-full overflow-hidden"
              >
                <img
                  src={g.src}
                  alt={lang === "en" ? g.alt_en : g.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.04] ${
                    g.tall ? "aspect-[3/4]" : "aspect-[4/3]"
                  }`}
                />
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active !== null && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-[#1F0A12]/92 p-5 sm:p-12 cursor-zoom-out"
          >
            <motion.img
              initial={{ scale: 0.94 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.96 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              src={GALLERY[active].src}
              alt={lang === "en" ? GALLERY[active].alt_en : GALLERY[active].alt}
              className="max-h-full max-w-full object-contain"
            />
            <button
              data-testid="gallery-lightbox-close"
              onClick={() => setActive(null)}
              className="absolute top-5 right-5 text-[#F5EFE6] p-2"
              aria-label="Chiudi"
            >
              <X size={26} strokeWidth={1.25} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
